import React from "react";

import { useDeferInputChange } from "hooks/use-deferred-input-change";
import { SelectionBaseProps } from "./types";
import { toneOfVoiceSuggestions } from "templates/shared-templates/common-fields";
import { ToneOfVoicePlain } from "./tone-of-voice-selection-plain";
import { selectStylesToOptionsFormat } from "selectors/settings";
import { useSelector } from "hooks/use-selector";
import { renderOptions } from "./option-renderer";
import { useTranslation } from "components/translate";
import { useBrandVoice } from "hooks/use-brand-voice";
import { useUserFromShopify } from "hooks/use-user";

export const ToneOfVoice = React.memo((props: SelectionBaseProps) => {
  const { value, onChangeWithValue } = useDeferInputChange({
    ...props,
    value: props.value || "",
    defaultValue: "",
  });
  const { t } = useTranslation("templates");

  const styles = useSelector(selectStylesToOptionsFormat);
  const { openAddStyle } = useBrandVoice();
  const addStyle = React.useCallback(() => {
    openAddStyle();
  }, []);
  const fromShopify = useUserFromShopify();

  return (
    <ToneOfVoicePlain
      optional={true}
      hideTitle={props.hideTitle}
      required={false}
      title={"Tone of voice"}
      autoCompleteSuggestions={[...styles, ...toneOfVoiceSuggestions]}
      value={value}
      placeholder={props.placeholder}
      autoCompleteProps={{
        renderOption: renderOptions,
      }}
      onChange={(event, value) => {
        onChangeWithValue(value.value);
      }}
      onInputChange={(event, value) => {
        onChangeWithValue(value);
      }}
      showStyle={fromShopify ? false : true}
      addStyle={addStyle}
    />
  );
});
